export default __webpack_public_path__ + "static/media/foreign-travel.69e50d9f.svg";